const protectedRoutes = [
  "dashboard-phone-verify",
  "dashboard-overview",

  "all-reviews",
  "review-details",
  "v3/dashboard/bookings/:bookingId/review",
  "update-review",

  "dashboard-payment",
  "get-notifications",
  "reservation-details",
  "update-notification-status",

  "send-sms-to-owner",
  "send-email-to-owner",

  "add-more-guest",

  "add-to-favourites",
  "remove-from-favourites",
  "get-favourites",

  "profile",
  "update-profile",
  "profile-reset-password",
  "profile-email-change",

  "get-user-like-properties",

  "v3/dashboard/overview",
  "v3/dashboard/bookings",
  "v3/dashboard/reviews",
  "v3/dashboard/payments",
  "v3/dashboard/favourites",
  "v3/dashboard/notifications",

  "v3/dashboard/bookings",
  "v3/dashboard/bookings/:bookingId",
  "v3/dashboard/bookings/:bookingId/special-request",
  "v3/dashboard/bookings/:bookingId/email",
  "v3/dashboard/bookings/:bookingId/cancel",
  "v3/dashboard/bookings/request/:bookingId/cancel",

  "v3/dashboard/messages/chats",
  "v3/dashboard/messages/chat/:bookingId",
  "v3/dashboard/messages/chat/:bookingId/mark-as-read/all",
  "v3/dashboard/messages/chat/:bookingId/mark-as-read/specific",

  "v3/dashboard/user/:userId/profile",
  "v3/dashboard/user/:userId/change-password",

  "v3/properties/:propertyId/likes",
  "v3/auth/signout",
  "v3/dashboard/notifications/mark-as-read",

  "v3/properties/user-like-lookup",

  "v3/dashboard/user/:userId/delete",
  "v3/dashboard/user/:userId",
  "v3/dashboard/user/:userId/change/email",
  "v3/dashboard/user/:userId/change/password",
  // there will be an issue when handling recommended auth routes, check that when handling booking part
];

export default protectedRoutes;
